<div class="cards-container-header">
  <div class="cards-container-header__headline-container">
    <i [ngClass]="['icon-' + icon, 'cards-container-header__icon']"></i>
    <span class="title-m primary-text">{{ title | translate }}</span>
  </div>
  @if (showButton) {
    <button im-button class="cards-container-header__button inverted btn-sm" (click)="onTap()">
      {{ buttonText | translate }}
    </button>
  }
</div>
